<template lang="pug">
v-dialog( v-model="open" :width="width")
  slot(name="activator" slot="activator")
  v-card.popupcard
    v-card-title.card-header(v-if="icon || title")
      .title
        v-icon(v-if="icon" dark) {{icon}}
        span {{title}}
      .action
        v-btn(icon dark @click="open = !open")
          v-icon close
    v-card-text.content
      .content-header
        slot(name="content-header")
      slot(name="content")
</template>

<script>
export default {
  props: {
    icon: {
      type: String
    },
    close: {
      type: Function
    },
    title: {
      type: String
    }
  },
  data: () => ({
    open: false
  }),
  created () { },
  methods: {
    onInput () {
      this.$emit('input', this.$refs.select.value)
    },
    closeDialog () {
      this.open = false
    },
    onChange () {
      this.$emit('change', this.$refs.select.value)
    }
  },
  computed: {
    width () {
      if (this.$vuetify.breakpoint.lgAndUp) return '30%'
      return 'auto'
    }
  }
}
</script>

<style lang="stylus" scoped>
.popupcard
  min-height 450px
  display flex
  flex-direction column
  text-align: justify;
.card-header
  height 20%
  display flex
  align-items center
  justify-content space-between
  padding .4em
  border-bottom .05em solid rgba(0,0,0,.05)
  box-shadow 0 2px 20px rgba(0,0,0,0.16)
  border-top .3em solid rgba(0,0,0,.12)
  background-color #004F27
  font-weight bold
  color white
  .title, .action
    display flex
    align-items center
  .title
    padding-left 1em
    justify-content flex-start
    span
      margin 0 0 0 1em
      font-size .8em
.content
  height 80%
  display flex
  flex-direction column
  justify-content center
  .content-header
    padding 0 0 1em 0
</style>
